import * as types from '../../constants/actionsType'
import moment from 'moment';

const initialState = {
  fromDate: '',
  toDate: '',
  isHoliday: true,
  dateFilter: 4,
  filterVal: "",
  isLogin: null,
  name: "",
  emailId: "",
  sessionId: "",
  department: "",
  emailConfirm: '',
  empCode: "",
  designation: "",
  userID: "",
  otpCode: '',
  companyName: '',
  token: "",
  isAdmin: '',
  roleId: "",
  subId: "",
  companyId: "",
  offlineTime: 3,
  offlineTimeEnable: false,
  loginFailedMsg: "",
  ShowCalender: true,
  isForgotPassword: false,
  isChangePassword: false,
  isSendMail: false,
  isVerifyOTP: false,
  forgotPasswordError: '',
  verifyOTPError: '',
  changePasswordMessage: '',
  changePasswordError: [],
  isLoadingSendMail: false,
  profileImage: "",
  data: [],
  SubscriptionFlag: false,
  filterData: [],
  loadFilter: true,
  isShowFilter: false,
  timeSheetUserID: '',
  timeSheetName: '',
  screenshotEnable: false,
  selectedRole: [],
  selectedDesignation: [],
  selectedTeam: [],
  selectedLocation: [],
  selectedGroup: [],
  selectedBusinessUnit: [],
  isShowInActiveUser: false,
  assetReportEnable: false,
  superUser: false,
  timesheetEmpCode:"",
  timeSheetDate:""

}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CHANGE_DATE:
      return {
        ...state,
        fromDate: action.from,
        toDate: action.to,
        isHoliday: action.isHoliday
      }

    case types.GET_USER_DETAILS_FOR_SUBSCRIPTION: {
      return {
        ...state,
        SubscriptionFlag: action.data
      }
    }
    case types.SUCCESS_LOGIN:
      return {
        ...state,
        isLogin: true,
        name: action.data != undefined ? action.data.name : "",
        emailId: action.data != undefined ? action.data.emailId : "",
        sessionId: action.data != undefined ? action.data.sessionId : "",
        department: action.data != undefined ? action.data.department : "",
        emailConfirm: action.data != undefined ? action.data.emailConfirm : "",
        empCode: action.data != undefined ? action.data.empCode : "",
        designation: action.data != undefined ? action.data.designation : "",
        userID: action.data != undefined ? action.data.userID : "",
        otpCode: action.data != undefined ? action.data.otpCode : "",
        companyName: action.data != undefined ? action.data.companyName : "",
        token: action.data != undefined ? action.data.token : "",
        isAdmin: action.data != undefined ? action.data.isAdmin : "",
        roleId: action.data != undefined ? action.data.data.list.roleId : "",
        subId: action.data != undefined ? action.data.subId : "",
        companyId: action.data != undefined ? action.data.companyId : "",
        screenshotEnable: action.data != undefined ? action.data.screenshotEnable : "",
        assetReportEnable: action.data != undefined ? action.data.assetReportEnable : "",
        superUser: action.data != undefined ? action.data.superUser : false
      }
    case types.FAILED_LOGIN:
      return {
        ...state,
        isLogin: false,
        loginFailedMsg: action.data
      }

    case types.REMOVE_FAILED_MSG:
      return {
        ...state,
        isLogin: null,
        loginFailedMsg: ''
      }

    case types.SAVE_USER_DETAILS:
      return {
        ...state,
        isLogin: true,
        name: action.data != undefined ? action.data.name : "",
        emailId: action.data != undefined ? action.data.emailId : "",
        sessionId: action.data != undefined ? action.data.sessionId : "",
        department: action.data != undefined ? action.data.department : "",
        emailConfirm: action.data != undefined ? action.data.emailConfirm : "",
        empCode: action.data != undefined ? action.data.empCode : "",
        designation: action.data != undefined ? action.data.designation : "",
        userID: action.data != undefined ? action.data.userID : "",
        otpCode: action.data != undefined ? action.data.otpCode : "",
        companyName: action.data != undefined ? action.data.companyName : "",
        token: action.data != undefined ? action.data.token : "",
        screenshotEnable: action.data != undefined ? action.data.screenshotEnable : "",
        assetReportEnable: action.data != undefined ? action.data.assetReportEnable : "",
        isAdmin: action.data != undefined ? action.data.isAdmin : "",
        roleId: action.data != undefined ? action.data.roleId : "",
        subId: action.data != undefined ? action.data.subId : "",
        superUser: action.data != undefined ? action.data.superUser : false,
        companyId: action.data != undefined ? action.data.companyId : "",
        offlineTime: action.data != undefined ? action.data.offlineTime : "",
        offlineTimeEnable: action.data != undefined ? action.data.offlineTimeEnable : "",
      }
    case types.SHOWCALENDAR:
      return {
        ...state,
        ShowCalender: action.data
      }
    case types.SHOW_FILTER:

      return {
        ...state,
        isShowFilter: action.data,
        // filterVal: ''
      }
    case types.SUCCESS_FORGOT_PASSWORD:
      return {
        ...state,
        userID: action.data,
        isForgotPassword: true,
        isChangePassword: false,
        isSendMail: false,
        isVerifyOTP: false,
        forgotPasswordError: '',

        verifyOTPError: '',
        changePasswordMessage: '',
        changePasswordError: [],

      }
    case types.FAILED_FORGOT_PASSWORD:
      return {
        ...state,
        forgotPasswordError: action.data,
        isForgotPassword: false,
        isChangePassword: false,
        isSendMail: false,
        isVerifyOTP: false,
        verifyOTPError: '',
        changePasswordMessage: '',
        changePasswordError: [],
      };
    case types.SUCCESS_SEND_MAIL:
      return {
        ...state,
        isLoadingSendMail: false,
        isSendMail: true
      };

    case types.FAILED_SEND_MAIL:
      return {
        ...state,
        isSendMail: false,
        forgotPasswordError: action.data,
        isLoadingSendMail: false,
      };
    case types.SUCCESS_RESEND_OTP:
      return {
        ...state,
        verifyOTPError: '',
      };

    case types.FAILED_RESEND_OTP:
      return {
        ...state,
        verifyOTPError: action.data,
      };
    case types.VERIFY_OTP_HIDE_MSG:
      return {
        ...state,
        verifyOTPError: ''
      };
    case types.SUCCESS_VERIFY_OTP:
      return {
        ...state,
        isVerifyOTP: false,
        isSendMail: false,
        isForgotPassword: false,
        isChangePassword: true
      };

    case types.FAILED_VERIFY_OTP:
      return {
        ...state,
        isVerifyOTP: false,
        verifyOTPError: action.data,
      };
    case types.SUCCESS_UPDATE_PASSWORD:
      return {
        ...state,
        isChangePassword: false,
        isSendMail: false,
        isVerifyOTP: false,
        changePasswordMessage: action.data
      };
    case types.FAILED_UPDATE_PASSWORD:
      return {
        ...state,
        changePasswordError: action.data,
      };
    case types.FETCH_SEND_MAIL:
      return {
        ...state,
        isLoadingSendMail: true
      };
    case types.UPDATE_PASSWORD_HIDE_MSG:
      return {
        ...state,
        changePasswordError: []
      };
    case types.GET_PROFILE_IMAGE:
      return {
        ...state,
        profileImage: action.data.length > 0 ? action.data[0].profileAvatar : ""
      }
    case types.FAILD_GET_PROFILE_IMAGE: {
      return {
        ...state,
        profileImage: "",
      }

    }
    case types.SUCCESS_FILTER: {
      return {
        ...state,
        filterData: action.data,
        loadFilter: false
      }
    }
    case types.FETCH_FILTER: {
      return {
        ...state,
        // filterData: [],
        // loadFilter: true
      }
    }
    case types.FAILED_FILTER: {
      return {
        ...state,
        filterData: [],
        loadFilter: false
      }
    }
    case types.SAVE_FILTER_VALUE: {
      debugger
      var data = ""
      if (action.data.length > 0) {
        data = action.data.join(";")
      }

      return {
        ...state,
        filterVal: data,
        selectedRole: action.role,
        selectedDesignation: action.designation,
        selectedTeam: action.team,
        selectedLocation: action.location,
        selectedGroup: action.group,
        selectedBusinessUnit: action.businessUnit,
        isShowInActiveUser: action.isShowInActiveUser,

      }
    }
    case types.UPDATE_DATE_TIME_SHEET:
      return {
        ...state,
        timeSheetUserID: action.userID,
        fromDate: action.fromDate,
        toDate: action.toDate,
        timeSheetName: action.name,
        timesheetEmpCode:action.empCode,
        timeSheetDate:action.timeSheetDate==""?action.fromDate:action.timeSheetDate
      }
    default:
      return state
  }
}
export default reducer
